export const AIGeneratorType = {
    DEFAULT: 1,
    LEVEL: 2,
    TAG: 3,
    ROLES: 4
};
